// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__fnEfK","logo":"Layout_logo__IxGkn"};